import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=49b39700&lang=scss&scoped=true"
script.__scopeId = "data-v-49b39700"

export default script